import { inject } from 'mobx-react';
import * as React from 'react';

import { useClickTracker } from '@shared-ui/clickstream-analytics-context';
import { useLocalization } from '@shared-ui/localization-context';

import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkRadioButton, UitkRadioButtonGroup } from 'uitk-react-radio-button';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

interface PetsRadioButtonGroupProps {
  enabled: boolean;
  onEnable: () => void;
  onDisable: () => void;
}

const EXCLUDE_PETS = 'EXCLUDE_PETS';
const INCLUDE_PETS = 'INCLUDE_PETS';

export const PetsRadioButtonGroup: React.FC<PetsRadioButtonGroupProps> = inject(
  'context',
  'currentHotel'
)(({ enabled, onEnable, onDisable }) => {
  const l10n = useLocalization();
  const track = useClickTracker();

  const [value, setValue] = React.useState(enabled ? INCLUDE_PETS : EXCLUDE_PETS);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const eventTarget = event.target.value;

    setValue(eventTarget);
    track(`HOT.SR.TravelersField.${eventTarget}`, `Travelers Field ${eventTarget}`);

    eventTarget === INCLUDE_PETS ? onEnable() : onDisable();
  };

  return (
    <UitkSpacing padding={{ blockend: 'twelve' }}>
      <div>
        <UitkRadioButtonGroup
          legendLabel={l10n.formatText('hotels.roomPicker.pets.label')}
          onChange={handleRadioChange}
          group="petsIncluded"
          selected={value}
        >
          <UitkLayoutFlex justifyContent="space-between" alignItems="center">
            <UitkLayoutFlexItem>
              <UitkText>{l10n.formatText('hotels.roomPicker.pets.title')}</UitkText>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <UitkLayoutFlex>
                <UitkLayoutFlexItem>
                  <UitkRadioButton id={EXCLUDE_PETS} value={EXCLUDE_PETS}>
                    {l10n.formatText('hotels.roomPicker.pets.exclude')}
                  </UitkRadioButton>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem>
                  <UitkRadioButton id={INCLUDE_PETS} value={INCLUDE_PETS}>
                    {l10n.formatText('hotels.roomPicker.pets.include')}
                  </UitkRadioButton>
                </UitkLayoutFlexItem>
              </UitkLayoutFlex>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkRadioButtonGroup>
      </div>
    </UitkSpacing>
  );
});
